module.exports = __webpack_public_path__ + "img/accessory_item_13.da118dc7.svg";